import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import {
  ErrorHandler,
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { LazyChunkErrorHandler } from '@core/services/lazy-chunk-error-handler';
import { NavigationOutcomeService } from '@core/services/navigation-outcome.service';
import { ApiBaseUrlInterceptor } from '@core/interceptors/api-base-url.interceptor';
import { ApiErrorInterceptor } from '@core/interceptors/api-error.interceptor';
import { ApiHeadersInterceptor } from '@core/interceptors/api-headers.interceptor';
import { AuthExpiredInterceptor } from '@core/interceptors/auth-expired.interceptor';
import { HttpWriteKeepAliveInterceptor } from '@core/interceptors/http-write-keep-alive.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule | null) {
    if (parentModule) {
      throw new Error('CoreModule must be imported only once, in AppModule.');
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        provideHttpClient(withInterceptorsFromDi()),
        { provide: ErrorHandler, useClass: LazyChunkErrorHandler },
        // Eager on purpose: the tracker has to be listening before the first
        // navigation, not from the first error that asks about one.
        provideAppInitializer(() => {
          inject(NavigationOutcomeService);
        }),
        // First in the chain: no interceptor below it can be aborted by a
        // subscriber that tore down while a write was in flight.
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpWriteKeepAliveInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiBaseUrlInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiHeadersInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthExpiredInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiErrorInterceptor,
          multi: true,
        },
      ],
    };
  }
}
